module.exports = __webpack_public_path__ + "assets/img/rim-ardeche.31e3d246.png";